import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Zoom } from 'react-reveal';
import { Link } from 'react-router-dom';

const AdmissionCourseCart = ({ singleCourse }) => {
    const { courseThubnail, courseTitle, price, _id } = singleCourse;

    return (
        <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg popularcart">
                    <img src={courseThubnail} alt={courseTitle} className='img-fluid mb-2' />
                    <h4 className='p-2 fw-bold '>{courseTitle}</h4>

                    <div className="course-outline1 d-flex align-items-center justify-content-between d-flex p-2">
                        <div className="title">
                            <h4 className='fw-bold mb-2 '><span className='fs-2'>৳ </span> {price}</h4>
                        </div>
                        <div className="coutbtn">
                            <Link to={`/freePaidCourseDetails/${_id}`}>
                                <button className="btn btn-success fs-5 mb-3">বিস্তারিত দেখুন <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
                            </Link>

                        </div>
                    </div>
                </div>
           </Zoom>
        </div>
    );
};

export default AdmissionCourseCart;